/* @flow */
export const validation = {
  headingMaxChar: 120,
  paragraphMaxChar: 1500,
  quoteMaxChar: 150,
  authorNameMaxChar: 50,
  authorPositionMaxChar: 50
}
